import { Field, InputType } from 'type-graphql'
import type { IAction } from '../../action'
import type { PaymentGatewayObject } from '../PaymentGatewayObject'
import type { PaymentGatewayProvider } from '../PaymentGatewayProviderEnum'

@InputType()
export class CreateCouponArgs {
  @Field(() => String)
  amount: number

  @Field(() => String)
  code?: string

  @Field(() => String)
  gatewayProvider?: PaymentGatewayProvider
}

export interface ICreateCoupon extends IAction<PaymentGatewayObject, CreateCouponArgs> {}
